export default "__VITE_ASSET__CTWaRagC__"